/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { StoreSchema } from '../models/store-schema';

@Injectable({
  providedIn: 'root',
})
export class StoresService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation storesGet
   */
  static readonly StoresGetPath = '/stores';

  /**
   * Get stores list
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesGet$Response(params?: {

  }): Observable<StrictHttpResponse<Array<StoreSchema>>> {

    const rb = new RequestBuilder(this.rootUrl, StoresService.StoresGetPath, 'get');
    if (params) {


    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StoreSchema>>;
      })
    );
  }

  /**
   * Get stores list
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `storesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storesGet(params?: {

  }): Observable<Array<StoreSchema>> {

    return this.storesGet$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StoreSchema>>) => r.body as Array<StoreSchema>)
    );
  }

  /**
   * Path part for operation storePost
   */
  static readonly StorePostPath = '/store';

  /**
   * Create a new store
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storePost$Response(params?: {
      body?: StoreSchema
  }): Observable<StrictHttpResponse<StoreSchema>> {

    const rb = new RequestBuilder(this.rootUrl, StoresService.StorePostPath, 'post');
    if (params) {


      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoreSchema>;
      })
    );
  }

  /**
   * Create a new store
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `storePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storePost(params?: {
      body?: StoreSchema
  }): Observable<StoreSchema> {

    return this.storePost$Response(params).pipe(
      map((r: StrictHttpResponse<StoreSchema>) => r.body as StoreSchema)
    );
  }

  /**
   * Path part for operation storeGet
   */
  static readonly StoreGetPath = '/store/{id}';

  /**
   * Read a store
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeGet$Response(params: {

    /**
     * ObjectId
     */
    id: string;

  }): Observable<StrictHttpResponse<StoreSchema>> {

    const rb = new RequestBuilder(this.rootUrl, StoresService.StoreGetPath, 'get');
    if (params) {

      rb.path('id', params.id, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoreSchema>;
      })
    );
  }

  /**
   * Read a store
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `storeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeGet(params: {

    /**
     * ObjectId
     */
    id: string;

  }): Observable<StoreSchema> {

    return this.storeGet$Response(params).pipe(
      map((r: StrictHttpResponse<StoreSchema>) => r.body as StoreSchema)
    );
  }

  /**
   * Path part for operation storePut
   */
  static readonly StorePutPath = '/store/{id}';

  /**
   * Modify a store
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storePut$Response(params: {

    /**
     * ObjectId
     */
    id: string;
      body?: StoreSchema
  }): Observable<StrictHttpResponse<StoreSchema>> {

    const rb = new RequestBuilder(this.rootUrl, StoresService.StorePutPath, 'put');
    if (params) {

      rb.path('id', params.id, {});

      rb.body(params.body, 'application/json');
    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoreSchema>;
      })
    );
  }

  /**
   * Modify a store
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `storePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  storePut(params: {

    /**
     * ObjectId
     */
    id: string;
      body?: StoreSchema
  }): Observable<StoreSchema> {

    return this.storePut$Response(params).pipe(
      map((r: StrictHttpResponse<StoreSchema>) => r.body as StoreSchema)
    );
  }

  /**
   * Path part for operation storeDelete
   */
  static readonly StoreDeletePath = '/store/{id}';

  /**
   * Delete a store
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `storeDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeDelete$Response(params: {

    /**
     * ObjectId
     */
    id: string;

  }): Observable<StrictHttpResponse<{ 'message'?: string }>> {

    const rb = new RequestBuilder(this.rootUrl, StoresService.StoreDeletePath, 'delete');
    if (params) {

      rb.path('id', params.id, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{ 'message'?: string }>;
      })
    );
  }

  /**
   * Delete a store
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `storeDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  storeDelete(params: {

    /**
     * ObjectId
     */
    id: string;

  }): Observable<{ 'message'?: string }> {

    return this.storeDelete$Response(params).pipe(
      map((r: StrictHttpResponse<{ 'message'?: string }>) => r.body as { 'message'?: string })
    );
  }

}
